import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import {
  RetailPosModule,
  InventoryModule,
  PurchasesModule,
  OrdersManagementModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  CrmModule,
  HrmModule,
  AccountingModule,
  ReportsModule,
  LeadsManagementModule,
  CouponsManagementModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  ProductionModule,
  RawMaterialsModule,
  ProductServiceModule,
} from "./CommonModules";

import CartContext from "./CartContext";
import { ECommerceB2CRetail } from "./ECommerceB2cRetail";

// Reusable FeatureSection component
const FeatureSection = ({ title, items }) => (
  <div className="mb-4">
    <h6 className="fw-semibold">{title}</h6>
    <ul className="mb-0 ps-3">
      {items.map((item, idx) => (
        <li key={idx}>{item}</li>
      ))}
    </ul>
  </div>
);

export class ErpServicing extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleTryNow = () => {
    const {
      userData,
      ShowUserLoginNew,
      SetSelectedProduct,
      prods,
      ProductType,
    } = this.context;

    if (userData.loginStatus !== "active") {
      ShowUserLoginNew(true);
    } else {
      const selected = prods.find(
        (p) => p.productType === ProductType.SupplyChain
      );
      SetSelectedProduct(selected);
    }
  };

  render() {
    if (this.context.EcSettings.length === 0) {
      return <></>;
    }
    return (
      <>
        {/* Hero Section */}
        <section className="container-fluid py-5 bg-white" id="posSection">
          <div className="container">
            <div className="row gx-5">
              <div className="col-12 border-start border-5 border-primary ps-3 mb-2">
                <h6 className="text-primary text-uppercase">
                  End-to-End ERP solution Product & Service{" "}
                </h6>
                <Row className="align-items-center py-4">
                  <Col md={9}>
                    <h4 className="display-6  mb-0">
                      All-In-One Solution for Service Providers (ERP)
                    </h4>
                  </Col>
                  <Col md={3} className="text-end">
                    <Button
                      variant="warning"
                      className="w-100"
                      as={Link}
                      to="/Checkout"
                      onClick={(e) =>
                        this.context.HandleTryNowButtonClick(
                          this.context.ProductType.SupplyChain
                        )
                      }
                    >
                      Buy
                    </Button>
                  </Col>
                </Row>
              </div>
              <div className="col-lg-12 mb-4">
                We are a leading provider of ERP solutions for Service
                providers, offering a comprehensive suite of modules to
                streamline your business workflows. Our ERP modules are designed
                to be <strong>easy to use</strong> and{" "}
                <strong>affordable</strong>.
                <br /> Our approach would cover from Product Procurement,
                Production to Sales(Online/Offline) and Delivery .
                <br /> Our ERP modules are designed to be{" "}
                <strong>easy to use</strong> and <strong>affordable</strong>.
                Our approach would cover from Product Procurement to
                Sales(Online/Offline) and Delivery.
              </div>

              <div className="col-lg-12 mb-lg-5 py-5">
                <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  // className="rounded shadow"
                  aria-label="POS software demo video"
                >
                  <source
                    src={
                      this.context.GetEcSettingValueByName(
                        "StorageBlobImageUrl"
                      ) + "ServicingErpVideo.mp4"
                    }
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>

              <Row className="align-items-center py-4">
                <Col md={9}>
                  <h4 className="display-6 mb-0 border-start border-5 border-primary ps-3">
                    Features and Benefits
                  </h4>
                </Col>
                <Col md={3} className="text-end">
                  <Button
                    variant="warning"
                    className="w-100"
                    as={Link}
                    to="/Checkout"
                    onClick={(e) =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.SupplyChain
                      )
                    }
                  >
                    Buy
                  </Button>
                </Col>
              </Row>

              <div className="col-lg-12">
                <div className="bg-light p-4 rounded shadow-sm">
                  {/* POS Feature Sections */}
                  <FeatureSection
                    title="Features & Benefits"
                    items={[
                      "Product Servicing Workflow Management",
                      "Service Booking Management",
                      "Job Cards",
                      "Purchase/Procurement Items Management",
                      "Suppliers Management",
                      "Inventory & Stocks Management",
                      "Point-Of-Sale (POS)",
                      "ECommerce B2C website",
                      "Orders Management",
                      "Packaging Management",
                      "Delivery Management",
                      "return and refund management",
                      "Customer Relationship Management (CRM)",
                      "Coupons Management",
                      "Accepts Cash, Card, UPI, QR Codes, COD, and Payment Gateway Integration",
                      "HR & Payroll Management",
                      "Accounting & Balance Sheet",
                      "AI-powered solutions",
                      "Real-time dashboard with sales, billing, and inventory reports",
                      "Advanced Reporting and Analytics",
                      "Free SSL and Custom domain",
                      "Use on any device: Phone, Tablet, or PC",
                      "Customer Reviews and Feedback Management",
                      "Service History Tracking",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ERP Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3">
            Explore Integrated ERP Modules That Power Your Business
          </h5>
          <Row className="g-3">
            {[
              ProductServiceModule,
              RawMaterialsModule,
              InventoryModule,
              PurchasesModule,
              RetailPosModule,
              ECommerceB2CModule,
              OrdersManagementModule,
              PackagingManagementModule,
              DeliveryManagementModule,
              CrmModule,
              CouponsManagementModule,
              HrmModule,
              AccountingModule,
              ReportsModule,
            ].map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  <Module />
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}
